"use client";
import { Html } from "@custom/schema";
import clsx from "clsx";
import React from "react";
export default function BlockQuote(param) {
    var text = param.text, author = param.author, role = param.role, className = param.className;
    return /*#__PURE__*/ React.createElement("blockquote", {
        className: clsx("border-l-[3px] border-l-yellow-500 pl-5 font-medium font-heading text-lg my-6 mr-8 format-text", className)
    }, /*#__PURE__*/ React.createElement(Html, {
        markup: text
    }), /*#__PURE__*/ React.createElement("cite", {
        className: "font-normal not-italic mt-3.5 block"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "block text-sm"
    }, author), /*#__PURE__*/ React.createElement("span", {
        className: "block text-xs text-gray-200 mt-1.5"
    }, role)));
}
